import { fromPromise } from 'xstate5';

import type {
  CustomizationDataInput,
  CustomizationDataResponse,
} from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const fetchCustomizationData = fromPromise<
  CustomizationDataResponse,
  CustomizationDataInput
>(async () => {
  throw new Error('`fetchCustomizationData` actor is not provided.');
});
